module.exports = __webpack_public_path__ + "image/github.9671cbfe.png";